<template>
  <div class="pro-page auto">
    <div class="imgbox auto"><img :src="url + '/activity/nlounge/new20260604/01.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/02.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/03.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/04.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/05.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/06.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/07.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/08.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/09.jpg?v=1'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new20260604/10.jpg?v=1'" alt=""></div>

    <div class="footer auto">
      <div class="nlounge-btn atuo">
        <img :src="url + '/activity/nlounge/nlounge-btn1.jpg'" id="nlounge-btn" alt="" @click="goNlounge">
      </div>
      <div class="nlounge-btn-my atuo">
        <img :src="url + '/activity/nlounge/nlounge-btn.png'" id="nlounge-btn-my" alt="" @click="goAppMy">
      </div>
    </div>

    <div class="tips-alert" v-if="showUpdate">
      <div class="tips-alert-content auto">
        <div class="tips-title auto fontBold">提示</div>
        <div class="tips-content auto">
          当前版本过低，请更新版本再试！
          <!-- {{ NVersion }} -->
        </div>
        <div class="tips-btn-box auto">
          <div class="tips-btn cur auto fontBold" @click="goDownload">去升级</div>
          <!-- <div class="tips-btn auto fontBold" v-if="!hideCancel" @click.stop="cancelHandle">{{cancelText}}</div> -->
        </div>
        <!-- <div class="tips-btn-cancel auto">
          <div @click.stop="cancelHandle">忽略此版本</div>
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>
import Config from '@/conf'
export default {
  data () {
    return {
      // url: 'https://elantran-cnd.vintro.cn/elantra_n_client_activity/images'
      url: Config.root + '/elantra_n_client_activity/images',
      showUpdate: false,
      NVersion: 0
    }
  },
  mounted(){
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        this.$wx.miniProgram.getEnv((res)=>{
           if (res.miniprogram) {
              // alert("在小程序里");
              this.$wx.miniProgram.postMessage({
                data: {
                  title: '全新现代高性能N品牌N Lounge'
                }
              })

           } else {
               console.log("不在小程序里");
           }
        })
    }
    // document.addEventListener('UniAppJSBridgeReady', function() {
    //   console.log('桥接层初始化完成，可以调用跳转方法');
    // });
  },
  methods: {
    goNlounge () {
      window.elantran.navigateTo({
        url: '/pages/experience/nlounge'
      })
    },
    goAppMy () {
      window.elantran.navigateTo({
        url: '/pages/center/order'
      })
    },
    goDownload () {
      this.$router.push('/download')
    }
  }
}
</script>

<style lang="scss" scoped>
.pro-page {
  background: #111111;
}
.nlounge-btn {
  img {
    width: 79.6vw;
    margin: 0 auto;
  }
}

.footer {
  padding: 5vw 0 5vw;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #000;
  .nlounge-btn-my {
    img {
      width: 17vw;
      margin: 3vw auto 0;
    }
  }
}


.tips-alert {
	position: fixed;
	display: flex;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
	background: rgba(0, 0, 0, .76);
	z-index: 999;
	align-items: center;
	justify-content: center;
}
.tips-alert-content {
	width: 84%;
	.tips-title{
		height: 50px;
		background: #fff;
		text-align: center;
		line-height: 50px;
		font-size: 17px;
		color: #000;
	}
	.tips-content {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 15px;
		color: #000;
		background: #fff;
		padding: 0 10%;
		height: 115px;
		// text-align: center;
	}
	.tips-btn-box {
		display: flex;
		background: #fff;
		padding-bottom: 16px;
		justify-content: center;
		gap: 13px;
		.tips-btn {
			width: 35%;
			text-align: center;
			background: #c2d6f0;
			height: 40px;
			color: #000;
			font-size: 15px;
			line-height: 40px;
		}
		.cur {
			background: #e33521;
			color: #fff;
		}
	}
  .tips-btn-boxbetween {
    // justify-content: space-between;
    .tips-btn {
      margin: 0 3vw;
    }
  }
}
.tips-btn-cancel {
	background: #fff;
	text-align: center;
	color: #666;
	font-size: 12px;
	padding-bottom: 20px;
	text-decoration: underline;
}
</style>